<template>
    <div>
        <div class="popup-dimmed on" />
        <div class="popup-wrapper on" style="width:100%;height:100%">
            <div class="popup-container">
                <div class="popup-body phpto-img-area">
                    <div>
                        <vue-cropper ref="cropper" :src="param.originSrc" />
                    </div>
                </div>

                <div class="popup-bottom phpto-img-area-bottom">
                    <div class="btn-wrapper photo-wrapper">
                        <button ref="btnUndo" class="btn btn-left-rotate photo-btn" @click="rotate(90)" />
                        <button ref="btnRedo" class="btn btn-right-rotate photo-btn" @click="rotate(-90)" />
                        <button class="btn btn-photo-cancel photo-btn" @click="reset" />
                        <button class="btn btn-photo-ok photo-btn" @click="cropImage" />
                    </div>
                </div>
            </div>
            <button class="popup-close" @click="close()">
                <span class="blind">닫기</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

//import { ImageEditor } from '@toast-ui/vue-image-editor';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import FileApi from '../../api/FileApi';
import CameraHelper from '../../helper/CameraHelper';

export default {
    name: 'PhotoLayer',
    components: { VueCropper },
    props: {
        param: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            useDefaultUI: false,
            options: {
                // for tui-image-editor component's "options" prop
                cssMaxWidth: 720,
                cssMaxHeight: 960
            },
            //MAX_RESOLUTION: 3264 * 2448 * 2,
            supportingFileAPI: !!(window.File && window.FileList && window.FileReader),
            rImageType: /data:(image\/.+);base64,/,
            shapeOpt: {
                fill: '#fff',
                stroke: '#000',
                strokeWidth: 30
            },
            cropImg: null
        };
    },
    computed: {
        ...mapState({})
    },
    watch: {
        param: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            deep: true,
            handler(val) {
                this.param = val;
                //this.resetImageEditor();
                //console.log(this.param);
            }
        }
    },
    beforeCreate() {},
    created() {},
    mounted() {
        this.resetImageEditor();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions([]),
        close() {
            this.param.isShow = false;
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);
        },
        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            if (confirm('이미지를 Crop 하시겠습니까?')) {
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
                const formData = new FormData();
                const now = new Date();
                const imageName = now.getTime() + '.jpg';

                formData.append('imgFile', CameraHelper.base64ToBlob(this.cropImg), imageName);
                formData.append('file_id', '');

                FileApi.imgUpload(formData).then(result => {
                    console.log(result.content.fileId);
                    this.$emit('setCropImage', this.param.idx, result.content.fileId, this.cropImg);
                });
            }

            //console.log(this.cropImg);
        },
        reset() {
            this.$refs.cropper.reset();
        }
    }
};
</script>
